import { createSelector } from 'reselect';
import { get, isEmpty } from 'lodash';
import { IPageEditorState } from './reducer';

const selectPageEditorState = (state: any): IPageEditorState => {
  return state.pageEditor;
};

export const getPageEditorState = createSelector(
  selectPageEditorState,
  pageEditorState => {
    return pageEditorState;
  },
);

export const getEditablePage = createSelector(
  selectPageEditorState,
  pageEditorState => {
    return pageEditorState.editableArticle;
  },
);

export const getEditablePageWordsCount = createSelector(
  getEditablePage,
  editablePage => {
    return get(editablePage, 'text', '')
      .split(' ')
      .filter((w: string) => !isEmpty(w)).length;
  },
);

export const getPageEditorFirstVisitState = createSelector(
  selectPageEditorState,
  pageEditorState => {
    return pageEditorState.firstTimeVisit;
  },
);



// WEBPACK FOOTER //
// ./src/containers/PagesHistory/PageEditor/selectors.ts